const REAL_RULE_MODES = new Set(['markup_amount', 'markup_percent', 'fixed_price']);

const normalizeRealRule = (rule) => {
  if (!rule || !REAL_RULE_MODES.has(rule.mode) || !['unit', 'kg'].includes(rule.basis)) {
    return null;
  }
  if (!['number', 'string'].includes(typeof rule.value)
    || String(rule.value).trim() === '') return null;
  const value = Number(rule.value);
  if (!Number.isFinite(value) || value < 0) return null;
  return { mode: rule.mode, value, basis: rule.basis };
};

// Call with the group's visible formats after applying the current filters.
// Missing rules are deliberately not a shared rule (including all-missing groups).
export const getSharedPriceRule = (formats) => {
  if (!Array.isArray(formats) || !formats.length) return null;
  const first = normalizeRealRule(formats[0]?.stockPriceRule);
  if (!first) return null;
  return formats.every((format) => {
    const rule = normalizeRealRule(format?.stockPriceRule);
    return rule && rule.mode === first.mode && rule.value === first.value && rule.basis === first.basis;
  }) ? first : null;
};

const ROW_COLORS = {
  product: { background: '#e8f0fc', hover: '#dce9fc', selected: '#d4e3fa', accent: '#1d4ed8', border: '#bfd2ee' },
  variety: { background: '#f3eefb', hover: '#ece3f8', selected: '#e6daf6', accent: '#7e22ce', border: '#ddcfed' },
  format: { background: '#ffffff', hover: '#f1f5f9', selected: '#e2e8f0', accent: '#475569', border: '#e2e8f0' },
};

// Keep each level's color stable across filtering, selection, and row order.
export const getQuickPriceRowStyle = (level, selected = false) => {
  const colors = ROW_COLORS[level];
  return {
    '--quick-price-row-background': selected ? colors.selected : colors.background,
    '--quick-price-row-hover': selected ? colors.selected : colors.hover,
    '--quick-price-row-accent': colors.accent,
    '--quick-price-row-border': colors.border,
  };
};
